<template>
	<ul class="itv-tags-list">
		<li v-for="(item, i) in content" :key="i" class="itv-tags-list__item">
			{{ item }}
		</li>
	</ul>
</template>

<script>
export default {
	name: 'TagsList',
	props: {
		content: {
			type: Array,
			default: () => {},
		},
	},
}
</script>
